import { FC, useEffect } from "react";
import { Connector, useAccount, useConnect } from "wagmi";
import { Session } from "@chromia/ft4";

import { useStoreSelector } from "../../../store/store";
import { blockchain } from "../../../settings";
import { iConfig } from "../../../interfaces/interfaces";
import { useDisconnect } from "../../../hooks/useDisconnect";


const WagmiHandler: FC = () => {
	const { address, connector } = useAccount();
	const { config, userAddress } = useStoreSelector(store => store.app);
	const { session } = useStoreSelector(store => store.chromia);
	const { provider } = useStoreSelector(store => store.UI);
	const { error } = useConnect();
	const disconnect = useDisconnect();

	useEffect(() => {
		blockchain === 'chromia' && chrConnect(address, connector, session);
		// eslint-disable-next-line
	}, [connector, session, address])
	/* useEffect(() => {
		blockchain === 'binance' && bscConnect(userAddress, address, connector, config);
		// eslint-disable-next-line
	}, [connector, config, address, userAddress]) */

	/* useEffect(() => {	// check this
		// console.log('connector: ', connector);
		const changeAccount = () => {
			console.log('account changed');
			window.location.reload();
		};
		// if (connector) {
		// 	connector.o
		// 	connector.on('change', changeAccount);
		// 	// connector.on('disconnect', disconnectAccount);
		// 	connector.on('disconnect', disconnect);
		// };
		// return () => {
		// 	connector?.off("change", changeAccount);
		// 	connector?.off('disconnect', disconnect);
		// };

		if (provider) {
			provider.on('change', changeAccount);
			// connector.on('disconnect', disconnectAccount);
			provider.on('disconnect', disconnect);
		};
		return () => {
			provider?.off("change", changeAccount);
			provider?.off('disconnect', disconnect);
		};

		// eslint-disable-next-line
	}, [connector]) */

	/* useEffect(() => {
		console.log('connector: ', connector)
		if (connector?.onAccountsChanged){	// should exists when wallet connected
			connector.onAccountsChanged()
		}
	}, [connector]) */
	useEffect(() => {
		// console.log('provider: ', provider, '\non: ', provider?.on, '\nonce: ', provider?.once, '\noff: ', provider?.off);

		if (provider?.once){
			// probably should look in _events for event names
			// provider.on('accountsChanged', (connectedAddresses: string[]) => {console.log('accountsChanged', connectedAddresses)});
			provider.once('accountsChanged', () => disconnect());	// just 'disconnect' uses array of adresses as prop
			// provider.on('disconnect', () => {console.log('disconnect')})
			// provider.once('disconnect', () => disconnect(true));
			provider.once('disconnect', () => disconnect());
			// provider.on('chainChanged', () => {console.log('chainChanged')})
		}
	}, [provider])

	useEffect(() => {
		if (!error) {
			return;
		}
		if (error.message === "Connector not found") {
			window.open("https://metamask.io/download", "_blank");
		}
	}, [error]);

	/* const bscConnect = async (
		storeAdress: string | null,
		newAddress: string | undefined,
		// connector: Connector<any, any> | undefined,
		connector: Connector | undefined,
		config: iConfig | null
	) => {
		if (newAddress && connector && config && !storeAdress){
			const bscConnect = await import('../../../utils/binance/connect');
			// bscConnect.connect(connector, newAddress, config);
			bscConnect.connect(provider, newAddress, config);
		}
	} */

	const chrConnect = async (
		userAddr: string | undefined,
		// connector: Connector<any, any> | undefined,
		connector: Connector | undefined,
		session: Session | null
	) => {
		if (userAddr && connector && !session){
			(await import('../../../utils/chromia/ft4/connect')).connect(connector, userAddr);
			// chrConnect.connect(provider, userAddr);
		}
	}


	return null;
}

export default WagmiHandler;